import axios from 'axios'
import React, { useState } from 'react'

const UpdateOpt = ({ setUpdateData, getTxnData }) => {
    const [isImage, setIsImage] = useState(false)
    const [image, setImage] = useState(null)
    const [max, setMax] = useState('')
    const [min, setMin] = useState('')
    const [operatorId, setOperatorId] = useState(getTxnData._id)
    console.log('====================================');
    console.log({ getTxnData });
    console.log('====================================');
    const token = localStorage.getItem('token');
    const handleUpdateOptImage = async () => {
        try {
            const formData = new FormData()
            formData.append('operatorId', operatorId)
            formData.append('images', image)
            formData.append('minAmount', min)
            formData.append('maxAmount', max)
            const response = await axios.patch(`https://bharatdarshan.app/api/operator/update-operator`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            setUpdateData('Table')
            console.log({ response });
        } catch (error) {
            console.log({ error });
        }
    }

    return (
        <>
            <div className="row">
                <div className="col align-self-end">
                    <button onClick={() => setUpdateData('Table')} >Go Back</button>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>OperatorName</th>
                                <th>OperatorCode</th>
                                <th>City</th>
                                <th>Icons</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{getTxnData?.OperatorName}</td>
                                <td>{getTxnData?.OperatorCode}</td>
                                <td>{getTxnData?.city}</td>
                                <td>
                                    <img src={getTxnData?.operatorImage} height={50} alt="Operator Icon" />
                                </td>
                                <td><button onClick={() => setIsImage(!isImage)} >{!isImage ? 'Change Image' : 'Cancel'}</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {isImage &&
                <div className="row">
                    <div className="col">
                        <div className="mb-3 col-lg-6">
                            <input type="file" className="form-control" onChange={(e) => setImage(e.target.files[0])} />
                        </div>


                        <div className="col-lg-3">
                            <div className="mb-3">

                                <input type="number" className="form-control" onChange={(e) => setMin(e.target.value)} placeholder="Min Amount" />
                            </div>
                        </div>

                        <div className="col-lg-3">
                            <div className="mb-3">

                                <input type="number" className="form-control" onChange={(e) => setMax(e.target.value)} placeholder="Max Amount" />
                            </div>
                        </div>
                        <button onClick={() => handleUpdateOptImage()}>Update Operator Icon</button>
                    </div>

                </div>
            }
        </>
    )
}

export default UpdateOpt
